(() => {
	const section = document.querySelector('#section-emplois');
	if (!section) return;

	const grid = section.querySelector('.wrapper');
	const cards = Array.from(grid.querySelectorAll('.item-poste'));
	const postField = document.querySelector('.form-group.poste input');
	const compactQuery = window.matchMedia('(max-width: 1199px)');
	const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
	const DURATION = 650;
	const EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
	const TRANSITION = `height ${DURATION}ms ${EASING}, margin-top ${DURATION}ms ${EASING}`;

	let openCard = null;
	let isAnimating = false;

	const getColumns = () => {
		const styles = window.getComputedStyle(grid);
		const columns = styles.gridTemplateColumns;
		if (!columns || columns === 'none') return 1;
		return columns.split(' ').filter(Boolean).length;
	};

	const getRowGap = () => parseFloat(window.getComputedStyle(grid).rowGap) || 0;

	const lastCardInRow = (card) => {
		const index = cards.indexOf(card);
		const cols = getColumns();
		const rowEnd = Math.min(Math.ceil((index + 1) / cols) * cols - 1, cards.length - 1);
		return cards[rowEnd];
	};

	const setExpanded = (card, isOpen) => {
		const toggle = card.querySelector('.js-emploi-more');
		if (!toggle) return;

		toggle.setAttribute('aria-expanded', String(isOpen));
		const label = toggle.querySelector('.btn-more-text');
		if (label) {
			label.textContent = isOpen ? 'Voir moins' : 'En savoir plus';
		}
	};

	const getOpenPanel = () => grid.querySelector('.content-full.is-open');

	const resetPanelStyles = (panel) => {
		panel.style.height = '';
		panel.style.marginTop = '';
		panel.style.overflow = '';
		panel.style.transition = '';
	};

	const waitForHeight = (panel) => new Promise((resolve) => {
		if (reducedMotion.matches) {
			resolve();
			return;
		}

		let done = false;
		const finish = () => {
			if (done) return;
			done = true;
			panel.removeEventListener('transitionend', onEnd);
			resolve();
		};
		const onEnd = (event) => {
			if (event.target === panel && event.propertyName === 'height') {
				finish();
			}
		};

		panel.addEventListener('transitionend', onEnd);
		window.setTimeout(finish, DURATION + 80);
	});

	const closePanel = async () => {
		if (!openCard) return;

		const card = openCard;
		const panel = getOpenPanel() || card.querySelector('.content-full');

		card.classList.remove('is-open');
		setExpanded(card, false);

		if (panel) {
			if (!reducedMotion.matches && panel.classList.contains('is-open')) {
				const gap = getRowGap();
				panel.style.overflow = 'hidden';
				panel.style.height = `${panel.scrollHeight}px`;
				panel.style.marginTop = '0px';
				panel.getBoundingClientRect();
				panel.style.transition = TRANSITION;
				panel.classList.remove('is-open');
				panel.style.height = '0px';
				panel.style.marginTop = `-${gap}px`;
				await waitForHeight(panel);
			} else {
				panel.classList.remove('is-open');
			}

			panel.hidden = true;
			resetPanelStyles(panel);
			card.appendChild(panel);
		}

		if (openCard === card) {
			openCard = null;
		}
	};

	const openPanel = async (card) => {
		const panel = card.querySelector('.content-full');
		if (!panel) return;

		lastCardInRow(card).after(panel);
		panel.hidden = false;
		panel.style.overflow = 'hidden';
		card.classList.add('is-open');
		setExpanded(card, true);
		openCard = card;

		if (reducedMotion.matches) {
			panel.classList.add('is-open');
			resetPanelStyles(panel);
			return;
		}

		const gap = getRowGap();
		panel.style.transition = 'none';
		panel.style.height = '0px';
		panel.style.marginTop = `-${gap}px`;
		panel.getBoundingClientRect();

		panel.style.transition = TRANSITION;
		panel.classList.add('is-open');
		panel.style.height = `${panel.scrollHeight}px`;
		panel.style.marginTop = '0px';

		await waitForHeight(panel);

		if (openCard === card) {
			panel.style.height = 'auto';
			panel.style.overflow = '';
		}
	};

	const toggleCard = async (card) => {
		if (!card || isAnimating) return;

		isAnimating = true;

		try {
			if (openCard === card) {
				await closePanel();
				return;
			}

			await closePanel();
			await openPanel(card);
		} finally {
			isAnimating = false;
		}
	};

	section.addEventListener('click', (event) => {
		const moreBtn = event.target.closest('.js-emploi-more');
		if (moreBtn) {
			event.preventDefault();
			toggleCard(moreBtn.closest('.item-poste'));
			return;
		}

		const lessBtn = event.target.closest('.js-emploi-less');
		if (lessBtn) {
			event.preventDefault();
			toggleCard(openCard);
			return;
		}

		const applyBtn = event.target.closest('.js-emploi-apply');
		if (applyBtn && postField) {
			const card = applyBtn.closest('.item-poste');
			const title = card?.querySelector('.title h4')?.textContent.trim() || '';
			postField.value = title;
		}
	});

	const repositionOpenPanel = () => {
		if (!openCard || isAnimating) return;
		const panel = getOpenPanel();
		if (!panel) return;
		lastCardInRow(openCard).after(panel);
	};

	if (typeof compactQuery.addEventListener === 'function') {
		compactQuery.addEventListener('change', repositionOpenPanel);
	} else if (typeof compactQuery.addListener === 'function') {
		compactQuery.addListener(repositionOpenPanel);
	}

	window.addEventListener('resize', repositionOpenPanel);
})();
